import React from 'react';
import { Box, Typography } from '@mui/material';
import { Grass, Water, FilterVintage } from '@mui/icons-material';
import { IBiodiversityUnit } from '../../core/interfaces/BNG-units.interface';
import { IProject } from '../../core/interfaces/project.interface';

interface ChartTabsProps {
  units: IBiodiversityUnit;
  project?: IProject;
}

const getNumber = (val: any) => {
  if (typeof val === 'number') return val;
  if (val && typeof val === 'object' && '$numberDecimal' in val) return Number(val.$numberDecimal);
  return 0;
};

const BNGTabs: React.FC<ChartTabsProps> = ({ units, project }) => {
  const habitatUnits =
    project?.habitatUnits && getNumber(project?.habitatUnits) !== 0
      ? getNumber(project?.habitatUnits)
      : units?.habitatUnits && getNumber(units?.habitatUnits) !== 0
        ? getNumber(units?.habitatUnits)
        : 0;
  const hedgerowUnits =
    project?.hedgerowUnits && getNumber(project?.hedgerowUnits) !== 0
      ? getNumber(project?.hedgerowUnits)
      : units?.hedgerowUnits && getNumber(units?.hedgerowUnits) !== 0
        ? getNumber(units?.hedgerowUnits)
        : 0;
  const watercourseUnits =
    project?.watercourseUnits && getNumber(project?.watercourseUnits) !== 0
      ? getNumber(project?.watercourseUnits)
      : units?.watercourseUnits && getNumber(units?.watercourseUnits) !== 0
        ? getNumber(units?.watercourseUnits)
        : 0;

  return (
    <Box width="100%" marginBottom="8px">
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1, width: '100%' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <FilterVintage sx={{ fontSize: 45, color: 'var(--orchid-purple)', marginTop: 1 }} />{' '}
          <Typography variant="h4" sx={{ marginTop: 2, fontWeight: 'bold' }}>
            {habitatUnits ? habitatUnits.toFixed(2) : 0}
          </Typography>
        </Box>
        <Typography variant="h6" sx={{ color: 'var(--orchid-purple)', textTransform: 'uppercase', mb: 1 }}>
          Habitat Units
        </Typography>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            width: '100%',
            gap: 8,
          }}
        >
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 0.5 }}>
            <Typography variant="h6" sx={{ color: 'var(--clover-green)', position: 'relative', zIndex: 1 }}>
              {hedgerowUnits}
            </Typography>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Grass sx={{ color: 'var(--clover-green)' }} />
              <Typography variant="body1" sx={{ color: 'var(--clover-green)' }}>
                Hedgerows
              </Typography>
            </Box>
          </Box>
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 0.5 }}>
            <Typography variant="h6" sx={{ color: 'var(--gentian-blue)', position: 'relative', zIndex: 1 }}>
              {watercourseUnits}
            </Typography>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Water sx={{ color: 'var(--gentian-blue)' }} />
              <Typography variant="body1" sx={{ color: 'var(--gentian-blue)' }}>
                Watercourses
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default BNGTabs;
